<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <path class="filled" d="M46.455,15H17.545a7.977,7.977,0,0,0-7.968,7.968V41.031A7.977,7.977,0,0,0,17.545,49h28.91a7.977,7.977,0,0,0,7.968-7.968V22.969A7.977,7.977,0,0,0,46.455,15Zm-28.91,4h28.91a3.972,3.972,0,0,1,3.968,3.968v1.888H13.577V22.969A3.972,3.972,0,0,1,17.545,19Zm28.91,26H17.545a3.972,3.972,0,0,1-3.968-3.968V31.857H50.423v9.174A3.972,3.972,0,0,1,46.455,45Z" fill="currentColor"/>
    <rect width="64" height="64" fill="none"/>
  </g>
</svg>
